// 1 - MOBILE
// 2 - DESKTOP
import view from '../../Enums';

var LandingImages = {};
let key = '';

// example of setting image
LandingImages['image_id'] = {};
LandingImages['image_id'][view.MOBILE] = 'image identifier for mobile image';
LandingImages['image_id'][view.DESKTOP] = 'image identifier for desktop image';

// Form assets
LandingImages['countries_form'] = {};
LandingImages['countries_form'][view.MOBILE] = 'countries_form';
LandingImages['countries_form'][view.DESKTOP] = 'countries_form';

LandingImages['oyo_guests_form'] = {};
LandingImages['oyo_guests_form'][view.MOBILE] = 'oyo_guests_form';
LandingImages['oyo_guests_form'][view.DESKTOP] = 'oyo_guests_form';

LandingImages['hotel_form'] = {};
LandingImages['hotel_form'][view.MOBILE] = 'hotel_form_icon';
LandingImages['hotel_form'][view.DESKTOP] = 'hotel_form_icon';

LandingImages['rooms_form'] = {};
LandingImages['rooms_form'][view.MOBILE] = 'rooms_form';
LandingImages['rooms_form'][view.DESKTOP] = 'rooms_form';

LandingImages['form_one_blur_image'] = {};
LandingImages['form_one_blur_image'][view.MOBILE] = 'form_one_blur_image';
LandingImages['form_one_blur_image'][view.DESKTOP] = 'form_one_blur_image';

LandingImages['oyo_form_image'] = {};
LandingImages['oyo_form_image'][view.MOBILE] = 'oyo_big_image_mobile';
LandingImages['oyo_form_image'][view.DESKTOP] = 'oyo_big_image_mobile';

LandingImages['oyo_form_image'] = {};
LandingImages['oyo_form_image'][view.MOBILE] = 'oyo_big_image_mobile';
LandingImages['oyo_form_image'][view.DESKTOP] = 'oyo_big_image_mobile';

key = 'gray_arrow_left';
LandingImages[key] = {};
LandingImages[key][view.MOBILE] = 'gray_arrow_left';
LandingImages[key][view.DESKTOP] = 'gray_arrow_left';

key = 'white_arrow_right';
LandingImages[key] = {};
LandingImages[key][view.MOBILE] = 'white_arrow_right';
LandingImages[key][view.DESKTOP] = 'white_arrow_right';

// Landing resources
LandingImages['down_arrow'] = {};
LandingImages['down_arrow'][view.MOBILE] = 'DOWN_ARROW';
LandingImages['down_arrow'][view.DESKTOP] = 'DOWN_ARROW';

LandingImages['info_icon'] = {};
LandingImages['info_icon'][view.MOBILE] = 'info_icon';
LandingImages['info_icon'][view.DESKTOP] = 'info_icon';

LandingImages['hotel_icon'] = {};
LandingImages['hotel_icon'][view.MOBILE] = 'hotel_icon';
LandingImages['hotel_icon'][view.DESKTOP] = 'hotel_icon';

LandingImages['house_icon'] = {};
LandingImages['house_icon'][view.MOBILE] = 'house_icon';
LandingImages['house_icon'][view.DESKTOP] = 'house_icon';

LandingImages['green_tick'] = {};
LandingImages['green_tick'][view.MOBILE] = 'green_tick';
LandingImages['green_tick'][view.DESKTOP] = 'green_tick';

LandingImages['mail_icon'] = {};
LandingImages['mail_icon'][view.MOBILE] = 'mail_icon_new';
LandingImages['mail_icon'][view.DESKTOP] = 'mail_icon';

LandingImages['call_icon'] = {};
LandingImages['call_icon'][view.MOBILE] = 'call_icon_new';
LandingImages['call_icon'][view.DESKTOP] = 'call_icon';

LandingImages['OYO_WHITE'] = {};
LandingImages['OYO_WHITE'][view.MOBILE] = 'OYO_ICON';
LandingImages['OYO_WHITE'][view.DESKTOP] = 'OYO_ICON';

LandingImages['oyo_big_image'] = {};
LandingImages['oyo_big_image'][view.MOBILE] = 'oyo_big_image_mobile';
LandingImages['oyo_big_image'][view.DESKTOP] = 'oyo_big_image_desktop';

LandingImages['oyo_big_image_sign_up'] = {};
LandingImages['oyo_big_image_sign_up'][view.MOBILE] =
  'oyo_big_image_sign_up_mobile';
LandingImages['oyo_big_image_sign_up'][view.DESKTOP] =
  'oyo_big_image_sign_up_desktop';

LandingImages['oyo_big_image_home'] = {};
LandingImages['oyo_big_image_home'][view.MOBILE] = 'oyo_big_image_home_mobile';
LandingImages['oyo_big_image_home'][view.DESKTOP] =
  'oyo_big_image_home_desktop';

LandingImages['oyo_white_icon'] = {};
LandingImages['oyo_white_icon'][view.MOBILE] = 'OYO_WHITE_ICON';
LandingImages['oyo_white_icon'][view.DESKTOP] = 'OYO_WHITE_ICON';

// OYO Stats
LandingImages['countries_image'] = {};
LandingImages['countries_image'][view.MOBILE] = 'countries';
LandingImages['countries_image'][view.DESKTOP] = 'countries';

LandingImages['rooms_image'] = {};
LandingImages['rooms_image'][view.MOBILE] = 'rooms';
LandingImages['rooms_image'][view.DESKTOP] = 'rooms';

LandingImages['oyo_guest_image'] = {};
LandingImages['oyo_guest_image'][view.MOBILE] = 'oyo_guest';
LandingImages['oyo_guest_image'][view.DESKTOP] = 'oyo_guest';

LandingImages['statue_of_liberty'] = {};
LandingImages['statue_of_liberty'][view.MOBILE] = 'statue_of_liberty_icon';
LandingImages['statue_of_liberty'][view.DESKTOP] = 'statue_of_liberty_icon';

// Why Join OYO?
LandingImages['channel'] = {};
LandingImages['channel'][view.MOBILE] = 'channel_management';
LandingImages['channel'][view.DESKTOP] = 'channel_management';

LandingImages['revenue_management'] = {};
LandingImages['revenue_management'][view.MOBILE] = 'revenue_management';
LandingImages['revenue_management'][view.DESKTOP] = 'revenue_management';

LandingImages['technology'] = {};
LandingImages['technology'][view.MOBILE] = 'technology_image';
LandingImages['technology'][view.DESKTOP] = 'technology_image';

LandingImages['guest_experience'] = {};
LandingImages['guest_experience'][view.MOBILE] = 'guest_experience_image';
LandingImages['guest_experience'][view.DESKTOP] = 'guest_experience_image';

// OYO OS Module
LandingImages['os_logo'] = {};
LandingImages['os_logo'][view.MOBILE] = 'oyo_os_logo';
LandingImages['os_logo'][view.DESKTOP] = 'oyo_os_logo';

LandingImages['os_bullet'] = {};
LandingImages['os_bullet'][view.MOBILE] = 'bullets_image';
LandingImages['os_bullet'][view.DESKTOP] = 'bullets_image';

LandingImages['oyo_logo'] = {};
LandingImages['oyo_logo'][view.MOBILE] = 'co_oyo_logo';
LandingImages['oyo_logo'][view.DESKTOP] = 'co_oyo_logo';

LandingImages['os_image'] = {};
LandingImages['os_image'][view.MOBILE] = 'oyo_os_image';
LandingImages['os_image'][view.DESKTOP] = 'oyo_os_image';

LandingImages['play'] = {};
LandingImages['play'][view.MOBILE] = 'play_button';
LandingImages['play'][view.DESKTOP] = 'play_button';

LandingImages['button_background'] = {};
LandingImages['button_background'][view.MOBILE] = 'play_button_background';
LandingImages['button_background'][view.DESKTOP] = 'play_button_background';

// Steps to partner with oyo
LandingImages['partner_with_oyo_step_1'] = {};
LandingImages['partner_with_oyo_step_1'][view.MOBILE] =
  'partner_with_oyo_step_1';
LandingImages['partner_with_oyo_step_1'][view.DESKTOP] =
  'partner_with_oyo_step_1';

LandingImages['partner_with_oyo_step_2'] = {};
LandingImages['partner_with_oyo_step_2'][view.MOBILE] =
  'partner_with_oyo_step_2';
LandingImages['partner_with_oyo_step_2'][view.DESKTOP] =
  'partner_with_oyo_step_2';

LandingImages['partner_with_oyo_step_3'] = {};
LandingImages['partner_with_oyo_step_3'][view.MOBILE] =
  'partner_with_oyo_step_3';
LandingImages['partner_with_oyo_step_3'][view.DESKTOP] =
  'partner_with_oyo_step_3';

LandingImages['partner_with_oyo_number_1'] = {};
LandingImages['partner_with_oyo_number_1'][view.MOBILE] =
  'partner_with_oyo_number_1';
LandingImages['partner_with_oyo_number_1'][view.DESKTOP] =
  'partner_with_oyo_number_1';

LandingImages['partner_with_oyo_number_2'] = {};
LandingImages['partner_with_oyo_number_2'][view.MOBILE] =
  'partner_with_oyo_number_2';
LandingImages['partner_with_oyo_number_2'][view.DESKTOP] =
  'partner_with_oyo_number_2';

LandingImages['partner_with_oyo_number_3'] = {};
LandingImages['partner_with_oyo_number_3'][view.MOBILE] =
  'partner_with_oyo_number_3';
LandingImages['partner_with_oyo_number_3'][view.DESKTOP] =
  'partner_with_oyo_number_3';

LandingImages['dotted_line'] = {};
LandingImages['dotted_line'][view.MOBILE] = 'dotted_curved_line';
LandingImages['dotted_line'][view.DESKTOP] = 'dotted_curved_line';

// People check in
LandingImages['people_check_in'] = {};
LandingImages['people_check_in'][view.MOBILE] = 'bottom_big_image_mobile';
LandingImages['people_check_in'][view.DESKTOP] = 'people_check_in_india';

// video banner
LandingImages['THUMB_ONE'] = {};
LandingImages['THUMB_ONE'][view.MOBILE] = 'THUMB_ONE';
LandingImages['THUMB_ONE'][view.DESKTOP] = 'THUMB_ONE';

LandingImages['THUMB_TWO'] = {};
LandingImages['THUMB_TWO'][view.MOBILE] = 'THUMB_TWO';
LandingImages['THUMB_TWO'][view.DESKTOP] = 'THUMB_TWO';

LandingImages['THUMB_THREE'] = {};
LandingImages['THUMB_THREE'][view.MOBILE] = 'THUMB_THREE';
LandingImages['THUMB_THREE'][view.DESKTOP] = 'THUMB_THREE';

// Footer resources
LandingImages['facebook_icon'] = {};
LandingImages['facebook_icon'][view.MOBILE] = 'facebook_icon';
LandingImages['facebook_icon'][view.DESKTOP] = 'facebook_icon';

LandingImages['instagram_icon'] = {};
LandingImages['instagram_icon'][view.MOBILE] = 'instagram_icon';
LandingImages['instagram_icon'][view.DESKTOP] = 'instagram_icon';

LandingImages['twitter_icon'] = {};
LandingImages['twitter_icon'][view.MOBILE] = 'twitter_icon';
LandingImages['twitter_icon'][view.DESKTOP] = 'twitter_icon';

LandingImages['youtube_icon'] = {};
LandingImages['youtube_icon'][view.MOBILE] = 'youtube_icon';
LandingImages['youtube_icon'][view.DESKTOP] = 'youtube_icon';

LandingImages['pinterest_icon'] = {};
LandingImages['pinterest_icon'][view.MOBILE] = 'pinterest_icon';
LandingImages['pinterest_icon'][view.DESKTOP] = 'pinterest_icon';

LandingImages['footer_oyo_logo'] = {};
LandingImages['footer_oyo_logo'][view.MOBILE] = 'footer_oyo_logo';
LandingImages['footer_oyo_logo'][view.DESKTOP] = 'footer_oyo_logo';

//form3 resource

LandingImages['success_icon'] = {};
LandingImages['success_icon'][view.MOBILE] = 'success_icon';
LandingImages['success_icon'][view.DESKTOP] = 'success_icon';

LandingImages['form3_footer_mail_icon'] = {};
LandingImages['form3_footer_mail_icon'][view.MOBILE] = 'form3_footer_mail_icon';
LandingImages['form3_footer_mail_icon'][view.DESKTOP] =
  'form3_footer_mail_icon';

LandingImages['form3_footer_phone_icon'] = {};
LandingImages['form3_footer_phone_icon'][view.MOBILE] =
  'form3_footer_phone_icon';
LandingImages['form3_footer_phone_icon'][view.DESKTOP] =
  'form3_footer_phone_icon';

//////////tnc page//////////////

const makeImageObj = key => ({ [view.DESKTOP]: key, [view.TAB]: key, [view.MOBILE]: key });

['my_IMG1', 'my_IMG2', 'my_IMG3', 'my_IMG4', 'my_IMG5', 'my_IMG'].forEach(key => LandingImages[key] = makeImageObj(key));

['ph_PH1', 'ph_PH2', 'ph_PH3', 'ph_PH4', 'ph_PH5', 'ph_PH6'].forEach(key => LandingImages[key] = makeImageObj(key));

[
    'th_THAI2', 'th_THAI3', 'th_THAI5', 'th_THAI6', 'th_THAI7', 'th_THAI8', 'th_THAI8_1', 'th_THAI8_2', 'th_THAI8_3', 'th_THAI9', 'th_THAI10'
].forEach(key => LandingImages[key] = makeImageObj(key));

['vn_VN1', 'vn_VN2', 'vn_VN3', 'vn_VN4', 'vn_VN5', 'vn_VN6', 'vn_VN7', 'vn_VN8'].forEach(key => LandingImages[key] = makeImageObj(key));

['id_ID1_new1', 'id_ID2_new1', 'id_ID3_new1'].forEach(key => LandingImages[key] = makeImageObj(key));

['threeCtag', 'threeCtwo', 'threeCthree', 'icon_bedroom'].forEach(key => LandingImages[key] = makeImageObj(key));


export default LandingImages;
